import {
    ChangeDetectionStrategy, Component, ContentChildren, HostBinding,
    Input, OnDestroy,
    QueryList, SkipSelf,
} from "@angular/core";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { CommonFieldManagerDirective } from "../field-manager.directive";
import { CommonFieldGroupListComponent } from "./field-group-list.component";

@Component({
    selector: "common-field-group",
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonFieldGroupComponent implements OnDestroy {
    @HostBinding("class") public classes = "u-hex-width-full u-flex-row u-hex-margin-bottom-tiny";
    @Input() public groupContext: any;
    @ContentChildren(CommonFieldManagerDirective, { descendants: true })
    public fields: QueryList<CommonFieldManagerDirective>;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @SkipSelf() public fieldGroupList: CommonFieldGroupListComponent,
    ) { }

    public ngOnDestroy(): void {
        if (this.fieldGroupList.groups.findIndex((group) => group.groupId === this.groupContext.groupId) === -1) {
            this.resetGroupFields();
        }
    }

    public resetGroupFields(): void {
        this.fields.forEach((field) => field.resetState());
    }
}
